import { render, staticRenderFns } from "./SupplierViewModal.vue?vue&type=template&id=e89d01fc&scoped=true"
import script from "./SupplierViewModal.vue?vue&type=script&lang=js"
export * from "./SupplierViewModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e89d01fc",
  null
  
)

export default component.exports